import React from 'react';
import { Buddy } from '../models/Buddy';
import './AnimalSelector.css';

function AnimalSelector({ onSelectAnimal }) {
  const selectableAnimals = Buddy.getSelectableAnimals();

  const handleSelectAnimal = (animalKey) => {
    onSelectAnimal(animalKey);
  };

  return (
    <div className="animal-selector-overlay">
      <div className="animal-selector-modal">
        <h2>🎉 Welcome to Your Journey!</h2>
        <p className="animal-selector-subtitle">
          Choose your companion to start your adventure
        </p>
        
        <div className="animal-grid">
          {selectableAnimals.map((animal) => (
            <button
              key={animal.key}
              className="animal-card"
              onClick={() => handleSelectAnimal(animal.key)}
            >
              <div className="animal-preview">
                <span className="animal-egg">{animal.emojis[0]}</span>
                <span className="animal-final">{animal.emojis[5]}</span>
              </div>
              <div className="animal-name">{animal.name}</div>
            </button>
          ))}
        </div>
        
        <div className="animal-selector-info">
          <p>💡 Your companion will evolve as you level up!</p>
        </div>
      </div>
    </div>
  );
}

export default AnimalSelector;
